import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosing1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M62.25,36a15.69,15.69,0,0,0-13.64,8,8.65,8.65,0,0,0-3.86-.92A8.82,8.82,0,0,0,36,52H78A15.87,15.87,0,0,0,62.25,36Z",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56,52a20,20,0,1,1,3.6-16",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 40,
			x2: 40,
			y2: 12,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 40,
			y1: 68,
			x2: 40,
			y2: 80,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 73,
			y1: 40,
			x2: 80,
			y2: 40,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: 40,
			x2: 12,
			y2: 40,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 68.28,
			y1: 11.72,
			x2: 59.8,
			y2: 20.2,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 20.2,
			y1: 59.8,
			x2: 11.72,
			y2: 68.28,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 59.8,
			y1: 59.8,
			x2: 68.28,
			y2: 68.28,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.72,
			y1: 11.72,
			x2: 20.2,
			y2: 20.2,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		})
	]
});
export default SvgClosing1;
